var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template tips"},[_c('div',{staticClass:"panel_wrap"},_vm._l((_vm.dataVal.Property.Placeholder),function(item,index){return _c('div',{key:index,staticClass:"panel_tips"},[_vm._v(_vm._s(item.Text))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }